import { useEffect, useState } from 'react';
import { ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LineChart, Line } from 'recharts';
import { analyticsApi } from '../../api/admin.js';

export default function HrAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { analyticsApi.hr().then(setData); }, []);
  if (!data) return <div className="muted">Loading…</div>;

  return (
    <section>
      <header className="page-header"><h1>HR Analytics</h1></header>
      <div className="grid-2">
        <div className="card">
          <h3>Attendance rate (last 30 days)</h3>
          <ResponsiveContainer width="100%" height={220}>
            <AreaChart data={data.attendance}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis domain={[0, 100]} />
              <Tooltip />
              <Area type="monotone" dataKey="rate" stroke="#2563eb" fill="#dbeafe" />
            </AreaChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h3>Headcount growth (12 months)</h3>
          <ResponsiveContainer width="100%" height={220}>
            <LineChart data={data.headcountGrowth}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="headcount" stroke="#16a34a" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h3>Leave balance utilization</h3>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data.leaveUtilization}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="type" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="used" fill="#2563eb" />
              <Bar dataKey="capacity" fill="#94a3b8" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="card">
          <h3>Training completion rate</h3>
          <div className="big-stat">{data.trainingCompletion.rate}%</div>
          <p className="muted small">{data.trainingCompletion.completed} completed of {data.trainingCompletion.total}</p>
        </div>
      </div>
    </section>
  );
}
